import type { FaireProductEntity } from "../../entity_types/product";

export const p_bz143i56pw: FaireProductEntity = {
  token: "p_bz143i56pw",
  type: "product",
  name: "Sugar Scrub - Vanilla",
  brandName: "The Little Market",
  imageUrl:
    "https://cdn.faire.com/fastly/01c7bd7a5aa8844ad0e848fc49bf6757f2a8fbb4ddb7d3d66913c211b310b3ff.jpeg",
  priceDollars: 11,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/9138a7f51153d9083cd2572f54c403a2729aed76aa6c9c4f62bbeeae17389094.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
